import React from 'react';
import ReactDOM from 'react-dom/client';
import { AdminAuthProvider } from "./context/AdminAuthContext";
import App from './App';
import { AuthProvider } from "./context/AuthContext";

const isAdmin = window.location.pathname.startsWith("/admin");


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    {isAdmin ? (
      <AdminAuthProvider>
        <App />
      </AdminAuthProvider>
    ) : (
      <AuthProvider>
        <App />
      </AuthProvider>
    )}
  </React.StrictMode>
);